import { 
    currencies,
    formatCurrency as priceFormat, 
    formatDate as dateFormat, 
    getImage, 
    formatName as nameFormat,
    getCurrencySymbol,
    formatCurrency,
    plainPrice 
} from './plugins.js';

export default {
    install(Vue) {
        // Register all formatters as prototype methods
        Vue.prototype.$plainPrice = plainPrice;
        Vue.prototype.$priceFormat = priceFormat;
        Vue.prototype.$dateFormat = dateFormat;
        Vue.prototype.$getImage = getImage;
        Vue.prototype.$nameFormat = nameFormat;
        Vue.prototype.$getCurrencySymbol = getCurrencySymbol;
        Vue.prototype.$formatCurrency = formatCurrency;
        
        // Also expose currencies list globally
        Vue.prototype.$currencies = currencies;

        // Register filters for Vue 2.x compatibility
        if (Vue.filter) {
            Vue.filter('price', priceFormat);
            Vue.filter('date', dateFormat);
            Vue.filter('name', nameFormat);
            Vue.filter('currency', formatCurrency);
        }
    }
};